<template>
  <sb-table
    variation="minimal"
    data-sb-regression="sb-expandable-sub-table-row"
    :rows="subRowsMap"
    :column-definitions="subrowColumnDefinitions"
    :selectable="subRowsTableSelectable"
    :selected-rows="selectedRows"
    @on-select="handleSelectedChange"
  />
</template>
<script>
import SbTable from '@src/components/Table/SbTable.vue';

const mapSubRowsWithId = (row) => ({ id: row.original?.id ?? row.id, ...row.original });

export default {
  name: 'SbExpandableSubTableRow',
  components: {
    SbTable,
  },
  props: {
    row: {
      type: Object,
      required: true,
    },
    columnDefinitions: {
      type: Array,
      required: true,
    },
    onRowSelected: {
      type: Function,
      required: true,
    },
    subrowColumnDefinitions: {
      type: Array,
      default: () => [],
    },
    subRowsTableSelectable: {
      type: String,
      default: null,
    },
    overrideParentOnOff: {
      type: Boolean,
      default: false,
    },
    indeterminateDefaultSelected: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    subRowsMap() {
      return this.row.subRows.map(mapSubRowsWithId);
    },
    selectedRows() {
      const selectedRows = this.row.subRows?.filter((r) => r.getIsSelected()) ?? [];
      return selectedRows.map(mapSubRowsWithId);
    },
  },
  methods: {
    handleSelectedChange(rows) {
      if (rows.length === this.subRowsMap.length) {
        // all rows selected
        this.row.subRows.forEach((r) => r.toggleSelected(true));
        if (this.overrideParentOnOff) this.row.toggleSelected(true);
      } else if (rows.length === 0) {
        // all rows unselected
        this.row.subRows.forEach((r) => r.toggleSelected(false));
        if (this.overrideParentOnOff) this.row.toggleSelected(false);
      } else {
        if (this.overrideParentOnOff && this.indeterminateDefaultSelected != null) {
          this.row.toggleSelected(this.indeterminateDefaultSelected);
        }
        // loop through selected and verify selected state matches the new results
        const selectedIds = rows.map((x) => x.id);
        const subrows = this.row.subRows ?? [];
        subrows.forEach((r) => {
          const isCurrentlySelected = r.getIsSelected();
          const inSelectedList = selectedIds.indexOf(r.id) > -1;
          if (isCurrentlySelected !== inSelectedList) {
            r.toggleSelected();
          }
        });
      }

      this.onRowSelected();
    },
  },
};
</script>
